import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function NotLogin() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  /**
   * No.800対応
   */
  return (
    <div id="loginfr">
      <div id="loginfr-in">
        <div>
          <img src="/images/cms_logo.png" alt="CMS-POC" />
          <p style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>{t('ログインしていません。')}</p>
          <Link to={`/${language}/login`}>
            <input type="submit" value={t('ログイン画面へ') || ''} />
          </Link>
        </div>
      </div>
    </div>
  );
}
export default NotLogin;
